import { Component } from 'react'
import { captureError } from '../lib/sentry'

/**
 * App-wide error boundary. A render error anywhere below the router will be
 * caught here and shown as a friendly recovery screen instead of a blank page.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    // Surface for debugging without leaking details to the UI.
    console.error('App error boundary caught:', error, info?.componentStack)
    // Report to Sentry (no-op unless VITE_SENTRY_DSN is set).
    captureError(error, { componentStack: info?.componentStack })
  }

  handleReload = () => {
    this.setState({ hasError: false })
    window.location.assign('/')
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div style={{ minHeight: '100vh', background: '#FAFAF8', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
        <div style={{ background: 'white', border: '1px solid #E5E0D8', borderRadius: '1.5rem', padding: '2.5rem 2rem', maxWidth: 420, width: '100%', textAlign: 'center', boxShadow: '0 8px 32px rgba(0,0,0,0.06)' }}>
          <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>🌸</div>
          <h1 style={{ fontFamily: 'Gibs, serif', fontWeight: 400, fontSize: '1.5rem', color: '#1A1A1A', margin: '0 0 0.75rem' }}>
            Something went wrong
          </h1>
          <p style={{ fontFamily: 'Nunito Sans, sans-serif', fontSize: '0.9rem', color: '#6B6B6B', lineHeight: 1.7, margin: '0 0 1.75rem' }}>
            We hit an unexpected hiccup. Your data is safe — let's get you back to a fresh page.
          </p>
          <button onClick={this.handleReload}
            style={{ fontFamily: 'Nunito Sans, sans-serif', fontWeight: 700, fontSize: '0.9rem', color: 'white', background: '#C4826A', border: 'none', borderRadius: 100, padding: '0.875rem 2rem', cursor: 'pointer' }}>
            Back to home
          </button>
          <p style={{ fontFamily: 'Nunito Sans, sans-serif', fontSize: '0.75rem', color: '#BCBCBC', margin: '1.25rem 0 0' }}>
            Still stuck? Email{' '}
            <a href="mailto:support@okoiya.com" style={{ color: '#C4826A', textDecoration: 'none', fontWeight: 600 }}>support@okoiya.com</a>
          </p>
        </div>
      </div>
    )
  }
}
